import { render } from "./FumeiApp.vue?vue&type=template&id=0d95715c&scoped=true"
import script from "./FumeiApp.vue?vue&type=script&lang=js"
export * from "./FumeiApp.vue?vue&type=script&lang=js"

import "./FumeiApp.vue?vue&type=style&index=0&id=0d95715c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d95715c"]])

export default __exports__